module.exports = __webpack_public_path__ + "static/aderant-0abea3273365b2070ad00cd98ac9e69d.png";